import type { TutorBillingRow } from './interfaces'

import { useTutorBillingStore } from './store'

interface TutorBillingSelectionReturn {
  isAllSelected: ComputedRef<boolean>
  summary: ComputedRef<string>
  isSelected: (row: TutorBillingRow) => boolean
  setToggleRow: (row: TutorBillingRow) => void
  setToggleAll: () => void
}

export const useTutorBillingSelection = (): TutorBillingSelectionReturn => {
  const store = useTutorBillingStore()

  const selectedIds = computed<Set<number>>(() => new Set(store.getSelectedIds))

  const isAllSelected = computed<boolean>(() => store.getRows.length > 0 && store.getRows.every(row => selectedIds.value.has(row.id)))

  const selectedCount = computed<number>(() => selectedIds.value.size)

  const summary = computed<string>(() => {
    const total = store.getMeta?.total ?? store.getRows.length

    return `${selectedCount.value} of ${total} records selected`
  })

  const isSelected = (row: TutorBillingRow): boolean => selectedIds.value.has(row.id)

  const setToggleRow = (row: TutorBillingRow): void => {
    store.toggleSelected(row.id)
  }

  const setToggleAll = (): void => {
    const pageIds = store.getRows.map(row => row.id)

    if (isAllSelected.value) {
      const pageIdSet = new Set(pageIds)
      store.setSelectedIds(store.getSelectedIds.filter(id => !pageIdSet.has(id)))

      return
    }

    store.setSelectedIds([...new Set([...store.getSelectedIds, ...pageIds])])
  }

  return {
    isAllSelected,
    summary,
    isSelected,
    setToggleRow,
    setToggleAll,
  }
}
